import React from 'react';
import { Box, Button, TextField, Typography, Paper } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useUpdateUserMutation } from "../../../features/users/usersApiSlice";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import styles from '../../../style';

const resetSchema = yup.object().shape({
    newPassword: yup.string().required("Required"),
    confirmPassword: yup.string()
        .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
        .required('Confirm Password is required'),
});

export default function ResetPassword() {
    const { username } = useAuth();
    const [updateUser] = useUpdateUserMutation();
    const navigate = useNavigate();

    const handleSubmit = async (values) => {
        const { newPassword } = values;
        
        // Assuming username is the ID for the user
        await updateUser({ username, password: newPassword });
        
        // Navigate to console after successful password update
        navigate('/console');
    };

    return (
        <div style={styles.root}>
            <Paper elevation={3} style={styles.paper}>
                <Typography variant="h4" style={{ color: "#FFF" }}>Reset Your Password</Typography>
                <Formik
                    initialValues={{ newPassword: '', confirmPassword: '' }}
                    validationSchema={resetSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="password"
                                label="New Password"
                                name="newPassword"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.newPassword}
                                error={!!touched.newPassword && !!errors.newPassword}
                                helperText={touched.newPassword && errors.newPassword}
                                InputProps={{ style: { color: "#FFF" } }}
                                InputLabelProps={{ style: { color: "#FFF" } }}
                            />
                            <TextField
                                fullWidth
                                variant="filled"
                                type="password"
                                label="Confirm New Password"
                                name="confirmPassword"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.confirmPassword}
                                error={!!touched.confirmPassword && !!errors.confirmPassword}
                                helperText={touched.confirmPassword && errors.confirmPassword}
                                InputProps={{ style: { color: "#FFF" } }}
                                InputLabelProps={{ style: { color: "#FFF" } }}
                            />
                            <Box display="flex" justifyContent="end" mt="20px">
                                <Button type="submit" color="secondary" variant="contained">
                                    Reset Password
                                </Button>
                            </Box>
                        </form>
                    )}
                </Formik>
            </Paper>
        </div>
    );
}